import { supabaseClient } from 'supabase'
import { requireDecided } from './deskDecisionError'

export type SwapImageParams = {
  id: number
  /** 1-based index into the raw item's stored images (1 = image_path). */
  index: number
  /** The public storage URL of that image; the RPC checks it matches (desk_bad_image). */
  mainPicture: string
}

/**
 * Show a different stored image of the raw item on the candidate
 * (`desk_swap_image`, D-08). Sets `desk_display_image_index`; the editor's own
 * `display_image_index` is never touched.
 *
 * Errors are thrown raw (22023 `desk_bad_image` included); a `false` result
 * throws DeskAlreadyDecidedError (D-11).
 */
export const swapImage = async ({ id, index, mainPicture }: SwapImageParams): Promise<true> => {
  const { data, error } = await supabaseClient.rpc('desk_swap_image', {
    p_id: id,
    p_index: index,
    p_main_picture: mainPicture
  })

  if (error) {
    throw error
  }
  return requireDecided('desk_swap_image', data)
}
